var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9 13.4243C10.4346 13.4243 13.3 10.5589 13.3 7.0243C13.3 3.48968 10.4346 0.624298 6.9 0.624298C3.36538 0.624298 0.5 3.48968 0.5 7.0243C0.5 10.5589 3.36538 13.4243 6.9 13.4243ZM9.86568 5.98998C10.1781 5.67756 10.1781 5.17103 9.86568 4.85861C9.55326 4.54619 9.04673 4.54619 8.73431 4.85861L6.1 7.49293L5.06568 6.45861C4.75326 6.14619 4.24673 6.14619 3.93431 6.45861C3.62189 6.77103 3.62189 7.27756 3.93431 7.58998L5.53431 9.18998C5.84673 9.5024 6.35326 9.5024 6.66568 9.18998L9.86568 5.98998Z",
    fill: "#059669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.3bbb171d1a29baced60ad7b0f50bbcef.svg";
export { ForwardRef as ReactComponent };